import { Box, makeStyles } from "@material-ui/core";
import React from "react";
import Footer from "./Footer";
import NavigationBar from "./NavigationBar";

const useStyles = makeStyles((theme) => ({
  page: {
    height: "auto",
    width: "100%",
    position: "relative",
  },
}));
export default function BlurBoxBackgroundContainer({ background, children }) {
  const classes = useStyles();
  return (
    <Box className={classes.page}>
      <NavigationBar />
      <div className={background} />
      {children}
      <Footer />
    </Box>
  );
}
